!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/recentSearch',['libs/ct_view', 'libs/ct_store', 'hotels/hotelPers', 'vendor/mustache', 'vendor/moment.min'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.View, CT.Store, CT.Pers, Mustache)
}('recentSearch', function(View, Store, Pers, Mustache) {

	function updateRecentSearchContainer(/* String */ city, /* String */html, /* String */recentAutoCompleteHtml){
		var tmp, $el = $(this.$el);
		var $r = $('#RecentSearch').show();
		if(!city) $r.html(html)
		else {
			if((tmp = $el.find('[data-city="' + city + '"]')).length > 0) tmp.html(html)
			else {
				var $li = $r.prepend(html).find('li');
				var l = $li.length
				if(l > CT.settings[CT.app].rcntSearchTrigger) $li.last().remove()
			}
		}
		$(recentAutoCompleteHtml).insertAfter("#Tags");
		// CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TS','H_Recent','Recent','100');
		$r.find("li").click(function(e){
			e.stopImmediatePropagation();
			CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TS','H_Recent_Click',($.inArray(this, $(this).parent().children()) + 1)+':'+$(this).attr('data-city')+':'+$(this).find('a').attr('href'),'100');
			//console.log("recentsearch click = "+$(this).attr("data-index"))
		})
	}

	var recentSearchView = View({
		$el: $('.recentSearches'),



		initialize: function() {
			$(".recentSearches").find(".cancelRecent").bind('click', this.cancelRecentFn);
		},


		bindEvent : function(){
			var $parent = $(".recentSearches").find("ul#RecentSearch li");
			$parent.find("a").bind('click' , this.navigateUrl);
		},	

		navigateUrl : function(evt){
			var evt = evt || window.event;
			var target = evt.currentTarget;
			CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_Home_RecentSrch_click',{});
			if($(target).attr("target") != "_blank"){
				evt.preventDefault();
				setTimeout(function() { 
					window.location.href= target.href;
				},200);
			}
		},


		hideRecent: function() {
			$(this.$el).hide();
		},

		showRecent: function() {
			$(this.$el).show();
		},


		cancelRecentFn: function(e) {
			var pers = new Pers();
			var refAnc = $(".recentSearches").find(".cancelRecent");
			CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_Home_closeRecentSrch_click',{});
			pers.clear('recent');
			this.$el.fadeOut();
		},


		render: function(/* Array */recentData, /* Object */shortList) {
			if(recentData.length < 1) return this.hideRecent()
			this.showRecent();

			var mustacheData = [];

			recentData = recentData.reverse(recentData);

			_.each(recentData, function(rsObj, index) {
				// template data for each recent search object
				var tmplData = {
					frmWhere: rsObj.ct,
					checkIn: rsObj.cid == '' ? '' : moment(rsObj.cid, "DD/MM/YYYY").format('D MMM, YYYY'),
					checkOut: rsObj.co == '' ? '' : moment(rsObj.co, "DD/MM/YYYY").format('D MMM, YYYY')
				};

				if(rsObj.ar == 'undefined')
					rsObj.ar = '';

				if(rsObj.hnm == 'undefined')
					rsObj.hnm = '';

				if(rsObj.poi == 'undefined')
					rsObj.poi = '';

				var adultArr = [];
				var childArr = [];
				var childAgeArr = [];

				// filling adults data
				_.each(rsObj.ad, function(val, idx){
					if(idx === 's')idx="";
					adultArr.push({
						"idx": idx,
						"val": val
					});
				})
				tmplData.adults = adultArr;

				// filling children data
				_.each(rsObj.cd, function(val, idx){
					childArr.push({
						"idx": idx,
						"val": val
					})
				})
				tmplData.childs = childArr;

				// filling children ages data
				_.each(rsObj.aoc, function(ageArr, objIdx){
					_.each(ageArr, function(age, idx){
							childAgeArr.push({
							"idx": objIdx,
							"val": age
						});
					})
				})
				tmplData.ages = childAgeArr;

				_.each(shortList, function(cityData, city){
					if(city === rsObj.ct)
						_.each(cityData, function(slArr, dateKey){
							tmplData.sl = slArr.length
							tmplData.shLst = slArr.join('-')
						})
				})
				
				if(rsObj.wg_rs != undefined){
					rsObj.cityName = "Getaways from " + rsObj.ct;
					rsObj.wgSearch = true;
					//rsObj.ct = "Gateways from " + rsObj.ct
				}else{
					rsObj.wgSearch = false;
					rsObj.cityName = rsObj.ct;
				}
				rsObj["index"] = index + 1;
				mustacheData.push($.extend(tmplData, rsObj))

			});

			// render recent search HTML
			if(mustacheData.length > 0){
			var recentSearch = {
				"recent": mustacheData.length === 1? mustacheData : _(mustacheData).uniq(function(obj, i){ return obj.ct }).first(CT.settings[CT.app].rcntSearchTrigger).value()

			};

			recentSearch.recent = _.map(recentSearch.recent, function(item){
				if(item.hnm){ item.hnmURL = encodeURIComponent(item.hnm); }
				return item;
			})

			var html = CT.to_html('RecentSearchTmpl', recentSearch);
			var recentAutoCompleteHtml = CT.to_html('RecentAutoCompleteTpl', recentSearch);
			updateRecentSearchContainer.call(this, mustacheData.length === 1? mustacheData[0].ct : null, html, recentAutoCompleteHtml)
			this.bindEvent();
			return this;
			}else{
				return this.hideRecent()
			}
		}
	})



	CT.subscribe('recent.update', function(lastSearchedObj){
		if(lastSearchedObj){
			var pers = new Pers()
			var mJson = CT.masterJson.get();

			if (mJson.cnm) {
				lastSearchedObj['from'] = mJson.cnm;
				lastSearchedObj['city'] = mJson.cnm;
			}
			if(CT.subProd && CT.subProd == "wg"){
				lastSearchedObj['wg'] = true;
			}
			lastSearchedObj.sd = new Date().getTime();
			var recents = pers.set('recent', lastSearchedObj);
			Store("Recents").set('lastFormSearch', lastSearchedObj);

		}
	})

	return recentSearchView;
	//http://localhost/hotels/results?from=JP Nagar, Bangalore Karnataka, India&dest_code=12 Oct, 0002&state=Karnataka&country=India&areaName=JP Nagar&hotelId=&city=Bangalore&depart_date=22 Dec, 2012&return_date=23 Dec, 2012&adults1=1&children1=0&num_rooms=1&loc=JP Nagar:a"
}, CT.cache.views)
;
